import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import nodeinstance from "../../nodeInstance";

const getFinOnArrivalData = createAsyncThunk("api/employees/onarrivalmedical?finance=1", async (token, type) => {
    try {
        const response = await nodeinstance.get("/employees/onarrivalmedical?finance=1", {
            headers: { Authorization: `Bearer ${token}` },
        });
        return response.data.data;
    } catch (e) {
        throw new Error(e.message);
    }
});


const FinOnArrivalDataSlice = createSlice({
    name: "insurance",
    initialState: {
        data: null,
        error: "",
        status: false,
        isLoading: false,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getFinOnArrivalData.fulfilled, (state, action) => {
                state.data = action.payload;
                state.isLoading = false;
                state.status = true;
            })
            .addCase(getFinOnArrivalData.pending, (state, action) => {
                state.isLoading = true;
            })
            .addCase(getFinOnArrivalData.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.error.message;
            });
    },
});

export { getFinOnArrivalData };
export default FinOnArrivalDataSlice.reducer;
